import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X, Home, MapPin, Package, Compass, Image, Info, Phone, MessageCircle, Instagram } from 'lucide-react';
import './Navbar.css';

const WHATSAPP = process.env.REACT_APP_WHATSAPP || '919395419651';
const INSTAGRAM = process.env.REACT_APP_INSTAGRAM || 'https://www.instagram.com/skyleaftravelss';

const links = [
  { to: '/', label: 'Home', icon: Home },
  { to: '/destinations', label: 'Destinations', icon: MapPin },
  { to: '/packages', label: 'Packages', icon: Package },
  { to: '/guides', label: 'State Guides', icon: Compass },
  { to: '/gallery', label: 'Gallery', icon: Image },
  { to: '/about', label: 'About', icon: Info },
  { to: '/contact', label: 'Contact', icon: Phone }
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
  }, [open]);

  useEffect(() => {
    if (!open) return undefined;
    const onKeyDown = (e) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open]);

  return (
    <>
      <header className="topbar">
        <div className="topbar-inner">
          <button className="navbar-burger" onClick={() => setOpen((v) => !v)} aria-label="Toggle menu">
            {open ? <X size={22} /> : <Menu size={22} />}
          </button>

          <Link to="/" className="navbar-logo" onClick={() => setOpen(false)}>
            <img src="/images/logo.jpg" alt="Skyleaf Travels" className="navbar-logo-img" width="60" height="60" />
          </Link>

          <div className="topbar-actions">
            <a href={INSTAGRAM} target="_blank" rel="noreferrer" className="topbar-icon-link" aria-label="Instagram">
              <Instagram size={18} />
            </a>
            <a href={`https://wa.me/${WHATSAPP}`} target="_blank" rel="noreferrer" className="topbar-icon-link" aria-label="WhatsApp">
              <MessageCircle size={18} />
            </a>
            <Link to="/contact" className="btn btn-primary btn-sm">Plan My Trip</Link>
          </div>
        </div>
      </header>

      <aside className="sidebar">
        <nav className="sidebar-nav" aria-label="Primary">
          {links.map((l) => (
            <NavLink key={l.to} to={l.to} end={l.to === '/'} className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <l.icon size={19} />
              <span>{l.label}</span>
            </NavLink>
          ))}
        </nav>
      </aside>

      {/* aria-hidden + tabIndex=-1 when closed: the max-height:0/overflow:hidden
          CSS below hides this visually, but without these, its links would
          still be reachable by keyboard Tab and announced by screen readers
          while "closed". */}
      <nav className={`navbar-mobile ${open ? 'open' : ''}`} aria-label="Mobile" aria-hidden={!open}>
        {links.map((l) => (
          <NavLink
            key={l.to}
            to={l.to}
            end={l.to === '/'}
            className="navbar-mobile-link"
            onClick={() => setOpen(false)}
            tabIndex={open ? undefined : -1}
          >
            <l.icon size={18} />
            {l.label}
          </NavLink>
        ))}
        <Link to="/contact" className="btn btn-primary btn-block" onClick={() => setOpen(false)} tabIndex={open ? undefined : -1}>
          Plan My Trip
        </Link>
      </nav>
      {open && <div className="navbar-mobile-backdrop" onClick={() => setOpen(false)} />}
    </>
  );
}
